package ru.malygin

import kotlin.String

public object BuildConfig {
  public val TEST_PROPERTY: String = "testValue"

  public val MODE: String = "PRODUCTION"

  public val VERSION: String = "0.9.7-1.1.0"

  public val VK_API: String =
      "2iehhfe22iehhfe22iehhfe2f32fdgi88822ieh2iehhfe24edi1002e00i0ihg24105d8i"

  public val VK_APP_ID: String = "51582010"

  public val VK_GROUP_ID: String = "1014995"

  public val VK_TOPIC_ID: String = "52215978"

  public val JVM_DB_USER: String = "ocizl_bwum_xwabozma"

  public val JVM_DB_PASSWORD: String = "drxoa_45821241_zilkb_55723809mlpqD"
}
